exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#goTop{width:100%}.kidClub_go_top{width:48px;height:48px;right:10px;bottom:17px;cursor:pointer;z-index:10;border-radius:50%;animation:translateY .2s linear forwards;-moz-animation:translateY .2s linear forwards;-ms-animation:translateY .2s linear forwards;-o-animation:translateY .2s linear forwards;position:fixed;background-color:rgba(0,0,0,.5)}.kidClub_go_top img{width:27px;height:15px;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-2f2d88cd","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ToTop.vue
// module id = 45
// module chunks = 0